var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H2C.9 0 0 .9 0 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5zM2 18V2h8v4h4v12zM12 8v5c0 2.21-1.79 4-4 4s-4-1.79-4-4V6.5a2.5 2.5 0 0 1 2.76-2.49C8.06 4.14 9 5.33 9 6.64V13H7V6.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V13c0 1.1.9 2 2 2s2-.9 2-2V8z"
  })));
};
export default SvgFile;